<template>
    <div class="test-service" v-if="$route.meta.showTestService">
        <div class="test-service-crumb">
            <a-breadcrumb separator=">">
                <a-breadcrumb-item>
                    <router-link to="/home">
                        <img src="../../assets/home/icon-home.svg" style="margin: 0 4px 4px 0" />首页
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item>在线委托</a-breadcrumb-item>
            </a-breadcrumb>
        </div>
        <div class="content">
            <div class="online-delegation">
                <button @click="delegation">立即委托</button>
            </div>
            <div class="test-service-query search-page">
                <div class="title">检测服务查询</div>
                <div class="search-input">
                    <a-input-search placeholder="请输入" size="large" @search="onSearch">
                        <a-button slot="enterButton">查询</a-button>
                    </a-input-search>
                </div>
                <div class="search-content" v-if="searching">
                    <div class="nav">
                        <div class="left">检测服务信息</div>
                        <div class="right">
                            <span style="margin-right: 8px" @click="openDetail(searchData)">查看详情</span>
                            <span @click="back">返回</span>
                        </div>
                    </div>
                    <div class="content">
                        <custom-form
                            v-if="searchData"
                            :panels="searchFields"
                            :readonly="true"
                            :fieldsValue="searchData"
                        ></custom-form>
                        <empty-result v-else></empty-result>
                        <!-- <a-button type="link">查看物流</a-button> -->
                    </div>
                </div>
                <div class="list-content" v-else>
                    <tab :tabs="tabs" @setValue="setTabValue"></tab>
                    <a-table
                        :columns="columns"
                        rowKey="id"
                        :data-source="folderList"
                        :scroll="{ y: 320 }"
                        :pagination="pagination"
                        :loading="loading"
                        @change="handleTableChange"
                    >
                        <template slot="cssStatus" slot-scope="text">
                            <span>{{ statusList[text] }}</span>
                        </template>
                        <template slot="companyname" slot-scope="text, record">
                            <span>{{ record.ext$.companyname }}</span>
                        </template>
                        <span slot="action" slot-scope="text, record">
                            <a style="display: block" @click="openDetail(record)">详情</a>
                            <a style="display: block">物流信息</a>

                            <a
                                style="display: block"
                                v-if="record.cssStatus === 'unsigned' || record.cssFolderSignStatus === '1'"
                                @click="downloadFile(record)"
                                >下载委托协议</a
                            >
                            <a
                                style="display: block"
                                v-if="record.cssStatus === 'completed'"
                                @click="investigation(record)"
                                >满意度调查</a
                            >
                            <a-upload
                                :multiple="false"
                                :showUploadList="false"
                                accept=".pdf"
                                :customRequest="handleFileChange"
                            >
                                <a
                                    style="display: block"
                                    v-if="record.cssStatus === 'unsigned'"
                                    @click="clickUpload(record)"
                                    >上传委托协议</a
                                >
                            </a-upload>
                        </span>
                    </a-table>
                </div>
            </div>
        </div>
    </div>
    <router-view v-else></router-view>
</template>

<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import tab from '../../components/tab.vue';
import customForm from '../../components/custom-form.vue';
import { mapActions, mapMutations, mapState } from 'vuex';
import emptyResult from '../query-service/components/empty-result.vue';
import service from '../../utils/service';
import { upload } from '../../common/api';

export default {
    components: { tab, customForm, emptyResult },

    data() {
        return {
            searching: false,
            tabValue: 'all',
            locale: zhCN,
            loading: false,
            current: 1,
            pageSize: 10,
            tabs: [
                { value: 'all', text: '全部', selected: true },
                { value: 'prepareAccept', text: '待受理', selected: false },
                { value: 'unsigned', text: '待签订', selected: false },
                { value: 'inspect', text: '检验中', selected: false },
                { value: 'completed', text: '已完成', selected: false }
            ],
            statusList: {
                prepareAccept: '待受理',
                unsigned: '待签订',
                inspect: '检验中',
                completed: '已完成'
            },
            columns: [
                {
                    title: '序号',
                    width: 60,
                    customRender: (text, record, index) => index + 1
                },
                // { title: '委托单号', dataIndex: 'id', align: 'center' },
                {
                    title: '委托状态',
                    dataIndex: 'cssStatus',
                    align: 'center',
                    scopedSlots: { customRender: 'cssStatus' }
                },
                {
                    title: '委托单位',
                    dataIndex: 'companyname',
                    align: 'center',
                    width: 200,
                    scopedSlots: { customRender: 'companyname' }
                },
                { title: '委托日期', dataIndex: 'createdTime', align: 'center' },
                { title: '样品类型', dataIndex: 'ext$.sampletypename', align: 'center' },
                { title: '合同号', dataIndex: 'contractCode', align: 'center' },
                {
                    title: '操作',
                    key: 'operation',
                    scopedSlots: { customRender: 'action' }
                }
            ],

            searchFields: [
                {
                    id: 'search',
                    gutter: 0,
                    readonly: true,
                    fieldGroup: [
                        [
                            {
                                label: '委托单号',
                                field: 'id',
                                span: 12,
                                labelCol: { span: 10 },
                                wrapperCol: { span: 14 }
                            },
                            {
                                label: '委托日期',
                                field: 'createdTime',
                                span: 12,
                                labelCol: { span: 10 },
                                wrapperCol: { span: 14 }
                            },
                            {
                                label: '委托状态',
                                field: 'statusDesc',
                                span: 12,
                                labelCol: { span: 10 },
                                wrapperCol: { span: 14 }
                            },
                            {
                                label: '样品类型',
                                field: 'ext$.sampletypename',
                                span: 12,
                                labelCol: { span: 10 },
                                wrapperCol: { span: 14 }
                            },
                            {
                                label: '合同号',
                                field: 'contractCode',
                                span: 12,
                                labelCol: { span: 10 },
                                wrapperCol: { span: 14 }
                            }
                        ]
                    ]
                }
            ],

            tableId: '',
            cssFolderId: '',
            searchData: null
        };
    },

    created() {
        this.getHideFields();
        this.getTableData();
    },

    watch: {
        '$route.meta.showTestService': {
            handler(val) {
                val && this.getTableData();
            },
            deep: true
        }
    },

    computed: {
        ...mapState('testService', ['folderList', 'total']),

        pagination() {
            return {
                total: this.total,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: this.pageSize,
                showTotal(total) {
                    return `总共${total}条`;
                },
                current: this.current
            };
        }
    },

    methods: {
        ...mapMutations(['changeSpinning']),
        ...mapActions('testService', [
            'createOnlineFolders',
            'getHideFields',
            'getFolderList',
            'getSelectOrderHideFields'
        ]),

        openDetail(d) {
            const folderId = d.cssFolderId;
            const params = {
                folderId
            };
            this.$router.push({ name: 'test-service-detail', query: params });
        },

        async getTableData() {
            this.loading = true;
            await this.getFolderList({
                f: { cssStatus: this.tabValue === 'all' ? '' : this.tabValue, dzyFlag_SEQ: '' },
                n: 1,
                s: this.pageSize,
                qf: {},
                o: [{ id: 'desc' }]
            });
            this.loading = false;
        },

        async onSearch(v) {
            try {
                this.loading = true;
                this.searching = true;
                await this.getFolderList({
                    f: { id_SEQ: v ?? 'null', dzyFlag_SEQ: '' },
                    n: 1,
                    s: this.pageSize,
                    qf: {},
                    o: [{ id: 'desc' }]
                });
                this.searchData = this.folderList[0];
                this.loading = false;
            } catch (error) {
                this.loading = false;
            }
        },

        async delegation() {
            this.changeSpinning(true);
            const folderId = (await this.createOnlineFolders()).data;
            const params = {
                folderId
            };
            this.$router.push({ name: 'test-service-online-delegation', query: params });
            this.changeSpinning(false);
        },

        setTabValue(v) {
            this.tabValue = v;
            this.getTableData();
        },

        async downloadFile(val) {
            let fileId = val.unSignedFolderId;
            if (val.cssFolderSignStatus == '1') {
                fileId = val.signedFolderId;
            }
            const res = await service.post(`/secure/css/module/online-folders/action/${fileId}/select-css-file`);
            const url = location.origin + res.data.downloadUrl;
            window.open(url);
        },
        async investigation(val) {
            let targetId = val.id;
            const url = location.origin + '/investigation?mouldId=888382790404576&targetId=' + targetId;
            window.open(url, '_blank');
        },
        async handleFileChange({ file }) {
            const { data } = await upload({
                name: file.name,
                file,
                targetId: `T_LIMS_ORDER$${this.tableId}`
            });
            if (data) {
                const params = {
                    b: [
                        'limsFolderServiceImpl',
                        [{ id: this.tableId, signedFolderId: data, cssFolderId: this.cssFolderId }]
                    ]
                };
                await service.put(`/secure/css/module/online-folders/action/update-folder-sign-info`, params);
                this.$message.success('上传成功！');
                this.loading = true;
                await this.getFolderList({
                    f: { cssStatus: this.tabValue === 'all' ? '' : this.tabValue, dzyFlag_SEQ: '' },
                    n: 1,
                    s: this.pageSize,
                    qf: {},
                    o: [{ id: 'desc' }]
                });
                this.loading = false;
            }
        },

        clickUpload(val) {
            this.tableId = val.id;
            this.cssFolderId = val.cssFolderId;
        },

        async handleTableChange(pagination) {
            this.current = pagination.current;
            this.pageSize = pagination.pageSize;
            this.loading = true;
            await this.getFolderList({
                f: { cssStatus: this.tabValue === 'all' ? '' : this.tabValue, dzyFlag_SEQ: '' },
                n: this.current,
                s: this.pageSize,
                qf: {},
                o: [{ id: 'desc' }]
            });
            this.loading = false;
        },

        async back() {
            this.searching = false;
            this.searchData = null;
            this.loading = true;
            await this.getFolderList({
                f: { cssStatus: this.tabValue === 'all' ? '' : this.tabValue, dzyFlag_SEQ: '' },
                n: 1,
                s: this.pageSize,
                qf: {},
                o: [{ id: 'desc' }]
            });
            this.loading = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.test-service {
    width: 100%;
    height: 100%;
    padding: 0 0 94px 0;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;

    > .test-service-crumb {
        width: 1200px;
    }

    > .content {
        width: 1200px;
        display: flex;
        justify-content: space-between;

        .online-delegation {
            width: 292px;
            height: 392px;
            background: url(../../assets/test-service/online-delegation-test.png) no-repeat;
            background-size: 100% 100%;

            button {
                background: transparent;
                border: 1px solid rgba(255, 255, 255, 1);
                border-radius: 4px;
                font-size: 18px;
                color: #ffffff;
                margin-top: 100px;
                margin-left: 32px;
                width: 104px;
                height: 32px;
                cursor: pointer;
            }
        }

        .test-service-query {
            width: 892px;
        }
    }
}
</style>
